<script lang="ts" context="module">
  import type { TransitionConfig } from "svelte/transition"
  import { ICON } from "./icon"

  export { ICON }
</script>

<script lang="ts">
  export let type: ICON
  export let size = 20
  export let transition: undefined | ((node: Element) => TransitionConfig) = undefined
</script>

{#await import(`./icons/${type}.svg?icon`) then icon}
  <svelte:component
    this={icon.default}
    class={$$restProps.class}
    style={`width: ${size}px; height: ${size}px`}
    {transition}
  />
{/await}
